<template>

    <b-row>
      <b-col md="2"
        ><a href="https://sportips.fr"
          ><img
            src="../../assets/logo.png"
            style="width: 100%; height: auto; max-width: 100px" /></a
      ></b-col>
      <b-col md="8">
        <p style="margin-bottom: 0">
          <v-icon style="color: #f29406" name="running" />
          <span style="font-weight: bold; font-size: 1.1em">Importation de résultats</span>
        </p>
      </b-col>
    </b-row>

</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },

};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/component/Import/TopBar.vue